module.exports = function() {
  return new Worker(__webpack_public_path__ + "fc0281027f00fddee38b.worker.js");
};